type EventType = 'live' | 'online' | 'secret';

export const parseEventType = (apiEventType?: string | null): EventType => {
  switch (apiEventType) {
    case 'live':
    case 'online':
    case 'secret': {
      return apiEventType;
    }
    default: {
      return 'live';
    }
  }
};
